import ApiResourceManager from '../ApiResourceManager';

export default class StripeManager extends ApiResourceManager {
  createSetupIntent = (data) =>
    this.request({
      method: 'POST',
      url: '/stripe/setup-intents',
      data,
    });

  createCheckoutSession = (data) =>
    this.request({
      method: 'POST',
      url: '/stripe/checkout-sessions',
      data,
    });
}
